import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, UntypedFormGroup } from "@angular/forms";
import { AdminService } from "../../../../../services/admin.service";
import { Message, SpinnerService } from "shared-components";

@Component({
  selector: "app-new-edit-param-certificado",
  templateUrl: "./new-edit.component.html",
})
export class NewEditParamCertificado implements OnInit {
  public newEditForm: UntypedFormGroup;
  public showError: boolean;
  public mensajes = new Array<Message>();
  public editable: boolean;
  public toCloseSpinner = 0;

  public allGrupoEtiquetasCaja;
  public allGrupoEtiquetasPallet;

  public grupoEtiquetaIdCaja;
  public grupoEtiquetaIdPallet;

  public finishUpdate = false;

  public refreshCheckbox_modoCertificados = false;
  public refreshCheckbox_modoEtiquetas = false;

  @Input() modoCertificado;
  @Input() modoEtiquetas;
  @Input() licenciaSwId;
  @Input() almacenId;
  @Input() denominacionId;
  @Input() paisId;

  @Output() refresh = new EventEmitter<boolean>();
  @Output() editableChanged = new EventEmitter<any>();
  @Output() close = new EventEmitter<boolean>();

  constructor(
    private _fb: FormBuilder,
    private _adminService: AdminService,
    private _spinnerService: SpinnerService,
  ) {}

  ngOnInit(): void {
    this.newEditForm = this._fb.group({
      modoCertificados: [this.checkboxBooleanToString(this.modoCertificado)],
      modoEtiquetas: [this.checkboxBooleanToString(this.modoEtiquetas)],
    });
  }

  private checkboxBooleanToString(val: boolean | null | undefined): string {
    return val === true ? 'true' : val === false ? 'false' : '';
  }

  public pristineCheckbox(idForm: string, pristine: boolean) {
      const form = this.newEditForm.get(idForm);
      pristine ? form.markAsPristine() : form.markAsDirty();
  }

  public edit() {
    this.editable = true;
  }

  public cancel() {
    this.editable = false;
    this.refreshCheckbox_modoCertificados = true;
    this.refreshCheckbox_modoEtiquetas = true;
  }

  public save() {
    if (this.newEditForm.get("modoCertificados")?.value === 'false' && this.newEditForm.get("modoEtiquetas")?.value === 'false') {
      this.showError = true;
      this.mensajes.push({
        class: "error",
        message: "global.error.modoCertEtiq",
      });
      return;
    }

    let filters = {
      licenciaSwId: this.licenciaSwId,
      paisId: this.paisId,
      denominacionId: this.denominacionId,
      almacenId: this.almacenId,
      modoCertificado: this.newEditForm.get("modoCertificados")?.value === 'true' ? true : this.newEditForm.get("modoCertificados")?.value === 'false' ? false : null,
      modoEtiquetas: this.newEditForm.get("modoEtiquetas")?.value  === 'true' ? true : this.newEditForm.get("modoEtiquetas")?.value === 'false' ? false : null,
    };

    this._spinnerService.showSpinner();
    this._adminService
      .updateCertificadosGestionLicencias(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then(
        (resp) => {
          this.refresh.emit(true);
          this.editableChanged.emit(false);
          this.editable = false;
          this.showError = true;
          this.mensajes.push({
            class: "success",
            message: "global.success.itemUpdated",
          });
        },
        (error) => {
          this.showError = true;
          this.mensajes.push({
            class: "error",
            message: "global.error.noResponse",
          });
        },
      );
  }
}
